import React from "react"
import { FixedSizeList } from "react-window"
import { colorsAvatar } from "../../core/utils/colorsAvatars"
import { Avatar } from "../Avatar"
import { CheckBox } from "../Form"
import { LoadingWithLabel } from "../Loading"
import ModalAlert from "../ModalAlert"
import { useMediaQuery } from "react-responsive"
import { useSelector } from "react-redux"
import "./styles.scss"
import { FaArrowUp, FaArrowDown } from "react-icons/fa"
import { RiArrowRightSLine } from "react-icons/ri"
import { InfoTooltip } from "../Tooltip"

const Variation = ({ variation }) => {
  const formattedVariation =
    variation && variation != "Infinity" ? `${parseFloat(variation).toFixed(0)}%` : 0
  const isPositive = variation >= 0

  return (
    <div className={`variation ${isPositive ? "positive" : "negative"}`}>
      {isPositive ? <FaArrowUp /> : <FaArrowDown />}
      <span>{formattedVariation}</span>
    </div>
  )
}

export const EsmListIndex = ({
  data,
  hideScroll,
  className,
  checked,
  changeOptions,
  goTo,
  changeCheck,
  checkbox = false,
  isDeletable = false,
  onDeleteUser,
  loading,
  tableLayout,
  goToUser,
}) => {
  const sidebarCollapsed = useSelector((state) => state.app.sidebarCollapsed)
  const width = !sidebarCollapsed ? "minimize-line" : ""

  const M = useMediaQuery({ query: "(max-height:768px)" })

  const Row = ({ index, style }) => {
    const row = data[index]

    return (
      <>
        {row && (
          <div style={style}>
            <li
              className={`esm-list-data-content${className ? " " + className : ""} ${
                isDeletable ? "hasDelete" : ""
              } ${checkbox ? "hasCheck" : ""}`}>
              {checkbox && (
                <CheckBox
                  name={row?.value}
                  value={row?.value}
                  type="checkbox"
                  checked={checked?.some((val) => val === row?.value)}
                  onChange={changeOptions}
                />
              )}
              <div className="esm-list-data-content__item" onClick={() => goTo(row)}>
                <div className="esm-list-data-content__item-user" title={row?.label}>
                  <Avatar
                    icon={row?.image}
                    backgroundColor={colorsAvatar[index % colorsAvatar.length]?.bgColor}
                    foregroundColor={colorsAvatar[index % colorsAvatar.length]?.color}
                  />
                  <div className={`esm-list-data-content__item-user-info ${width}`}>
                    <span>{row?.label}</span>
                    <span>{`${row?.email || ""}`}</span>
                  </div>
                </div>
              </div>
              <div className="esm-list-data-content__item" onClick={() => goTo(row)}>
                <div className="esm-list-data-content__item-badge-component">
                  {row?.badge && row?.badge}
                </div>
              </div>
              <div
                className="esm-list-data-content__item"
                onClick={() => goTo(row)}
                title={row?.data}>
                <span>{row.data}</span>
              </div>
              <div
                className="esm-list-data-content__item pontuation"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  gridGap: 5,
                  display: "flex",
                }}
                onClick={() => goTo(row)}
                title={`Nota ${row?.pontuation}`}>
                <span>{row?.pontuation.toFixed(1)}</span>
                <Variation variation={row?.variation || 0} />
              </div>
              <div className="esm-list-data-content__item">
                {isDeletable && (
                  <div
                    className="esm-list-data-content__item-button-delete"
                    title="Excluir Usuário">
                    <button
                      onClick={() =>
                        ModalAlert.danger({
                          title: "Deseja remover este usuário ?",
                          confirmLabel: "Confirmar",
                          onConfirm: () => {
                            onDeleteUser(row?.item?.scaleProducerId || "")
                          },
                        })
                      }>
                      <i className="fi fi-ss-trash"></i>
                    </button>
                  </div>
                )}
                <div
                  className="esm-list-data-content__item-button-arrow"
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    goToUser(row)
                  }}>
                  <InfoTooltip
                    info="Visitar perfil do produtor"
                    trigger="hover"
                    children={<RiArrowRightSLine />}
                  />
                </div>
              </div>
            </li>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <div className={`esm-list-data${className ? " " + className : ""}`}>
        <div
          className={`esm-list-data-content-header ${checkbox ? "hasCheck" : ""} ${
            isDeletable ? "hasDelete" : ""
          }`}>
          {checkbox && (
            <CheckBox
              onChange={(event) => changeCheck(false, event.target.value)}
              value={checked?.length === data?.length ? false : true}
              checked={checked?.length === data?.length && data?.length !== 0}
            />
          )}
          <span>{tableLayout?.columnNames ? tableLayout?.columnNames[0] : "Produtores"}</span>
          <span>{tableLayout?.columnNames ? tableLayout?.columnNames[1] : "Esm"}</span>
          <span>{tableLayout?.columnNames ? tableLayout?.columnNames[2] : "Atualização"}</span>
          <div className="pontuation" style={{ display: "flex", justifyContent: "center" }}>
            <span>{tableLayout?.columnNames ? tableLayout?.columnNames[3] : "Nota"}</span>
          </div>
          {isDeletable && <span className="isDeletable">Excluir</span>}
          <span>Ação</span>
        </div>
        {loading ? (
          <div className="empty-table">
            <LoadingWithLabel
              labelLoading="Aguarde, buscando dados do esm..."
              colorSpinner="primary"
            />
          </div>
        ) : data.length > 0 ? (
          <div className="esm-table-data">
            <FixedSizeList
              height={M ? 538 : 550}
              itemCount={data.length}
              itemSize={80}
              width={"100%"}
              itemData={data}
              innerElementType="ul"
              className={hideScroll ? "list-view-hide-scroll" : "list-view-scroll-style"}>
              {Row}
            </FixedSizeList>
          </div>
        ) : (
          <div className="empty-table">
            <span>Não há dados</span>
          </div>
        )}
      </div>
    </>
  )
}
